/**
 * @typedef {Object} DiscountInfo
 * @property {number} price
 * @property {number} discountPercentage
 * @property {number} discountedPrice
 * @property {number} discount
 * @property {string} discountFormat
 */

import { formatValueToReal } from "./utilities";

/**
 * @typedef {Object} Payment
 * @property {number} id
 * @property {string} discount
 * @property {string} type_id
 * @property {number} price
 * @property {string} priceFormat
 */

/**
 * @typedef {Object} Parcels
 * @property {number} n
 * @property {string} cost
 * @property {string} costFormated
 * @property {string|number} value
 * @property {string} valueFormated
 */

/**
 * @typedef {Object} ClientData
 * @property {number} type_id
 * @property {DiscountInfo} discountInfo
 * @property {Payment[]} payments
 * @property {Parcels[]} parcelsTable
 */

export class ClientPrices {
  /**
   * @type {ClientData[]}
   */
  clients = [];
  /**
   * @type {{type_id:number,id:number}|null}
   */
  personData;

  constructor() {
    this.#loadClientPrices();
    this.#loadPersonData();
  }

  getPersonType() {
    return null != this.personData ? this.personData.type_id : null;
  }

  isLogged() {
    return null != this.personData;
  }

  /** @returns { false|ClientData } */
  getLoggedClientPrices() {
    if (!this.isLogged()) return false;
    const personType = this.getPersonType();
    if (!personType) return false;


    for(let i=0; i < this.clients.length; i++) {
      if (this.clients[i].type_id == personType && this.clients[i].discountInfo.discount > 0) {
        return this.clients[i];
      }
    }
    
    return false;
  }

  #loadClientPrices() {
    try {
      const clientPrices = document.querySelector("script#client_prices")?.innerHTML;
      if (clientPrices) {
        const json = atob(clientPrices);
        const data = JSON.parse(json);
        if (Array.isArray(data)) this.clients = data.map(d => d);
      }
    } catch (error) {
      console.error(error);
    }
  }

  #loadPersonData() {
    try {
      const personData = document.querySelector("script#personData")?.innerHTML;
      if (personData) {
        this.personData = JSON.parse(personData)
      }
    } catch (error) {
      console.error(error);
    }
  }
}

window.ClientPrices = ClientPrices;

/**
 * 
 * @param {ClientData} clientData 
 */
export function updateProductPricesHtml(clientData){
  const {payments, discountInfo, parcelsTable} = clientData;
  
  const cashPayment = payments.filter(payment => payment.class == "pix")[0];
  const cashPrice = cashPayment.priceFormat;
  
  updateCashPriceHtml(cashPrice);
  updatePriceHtml(discountInfo.discountedPrice);
  const maxNoRateIndex = updateParcelsTable(parcelsTable);
  updateParcelToggle(parcelsTable[maxNoRateIndex]);

}

/**
 * 
 * @param {string} price 
 */
function updateCashPriceHtml(price){
  document.querySelector("#form-product-buy span#price span.value").innerHTML = `R$ ${price}`;
  document.querySelector(".barra-fixa-content .final-price").innerHTML = `R$ ${price}`;
}

/**
 * 
 * @param {string} price 
 */
function updatePriceHtml(price){
  const formatedPrice = formatValueToReal(price);
  document.querySelector("#form-product-buy span#price.credit span").innerHTML = `${formatedPrice}`;
}

/**
 * 
 * @param {Parcels[]} parcels 
 * @returns {Number} 
 */
function updateParcelsTable(parcels){
  const oldLines = document.querySelectorAll('#parcelas-do-cartao tr:not(.tr-topo)');
  let maxNoRateIndex = 0;
  oldLines.forEach((line) => {
    line.innerHTML = "";
  })

  parcels.forEach(({n, valueFormated, cost, costFormated}, index) => {
    maxNoRateIndex = cost == 0 ? index : maxNoRateIndex;

    const _cost = cost > 0 ? costFormated + " a.m." : "sem juros";
    const html = `
      <tr> 
        <td class="n">${n} x de</td> 
        <td class="value">${valueFormated}</td> 
        <td class="cost">${_cost} </td> 
      </tr>`;

    document.querySelector('#parcelas-do-cartao tbody').insertAdjacentHTML('beforeend', html);
  });

  return maxNoRateIndex;
}

/**
 * 
 * @param {Parcels} parcel 
 */
function updateParcelToggle(parcel){
  document.querySelector(".dropdown-parcels #dropdownMenuButton strong:first-of-type").innerHTML = `${parcel.n}x`
  document.querySelector(".dropdown-parcels #dropdownMenuButton strong:nth-of-type(2)").innerHTML = `R$ ${parcel.valueFormated}`
}